<template>
  <div v-if="items">
    <v-data-table
      v-model="selected"
      fixed-header
      light
      dense
      show-select
      :items="items"
      :headers="headers"
      :sort-by.sync="orderBy"
      :sort-desc.sync="sortOrder"
      :items-per-page="itemPerPage"
      item-key="id"
      class="m-2 font-weight-bold cursor"
      hide-default-footer
      mobile-breakpoint="40"
    >
      <!--    no-data-->
      <template v-slot:no-data> NO DATA HERE! </template>
      <template v-slot:no-results> NO RESULTS HERE! </template>
      <!--    no-data end-->

      <!--    table top-->
      <template v-slot:top>
        <div
          class="ma-0 mb-10 pa-0 d-flex justify-space-between align-center flex-wrap"
          :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
        >
          <datatable-detail
            :table_properties="table_properties"
            v-if="$vuetify.breakpoint.smAndUp"
          ></datatable-detail>
          <div
            v-else
            class="d-flex align-center justify-space-between mb-3 w-100"
          >
            <datatable-detail
              :table_properties="table_properties"
            ></datatable-detail>
            <b-button
              v-show="$vuetify.breakpoint.xsOnly"
              depressed
              small
              variant="outline-primary"
              class="px-5 py-3 mb-1 btn--tools"
              @click="toolBarVisionState = !toolBarVisionState"
            >
              TOOLS
            </b-button>
          </div>
          <div
            v-show="isToolbarVisiable"
            style="display: flex; justify-content: center; align-items: center"
            class="card-toolbar ma-0 pa-0 col-md-8 col-sm-10 col-12 row justify-content-start justify-content-sm-end justify-content-md-end align-center align-content-center"
          >
            <div
              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"
              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="permissionChecker('create')"
            >
              <button
                @click.prevent="showAddItemModal"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-plus-box-outline</v-icon>
                </span>
                Add {{ table_properties.title }}
              </button>
            </div>
            <add-products
              :loader="pageLoad"
              :refresher="updateTableContent"
              :brands="brands"
              :parameters="parameters"
              :stores="stores"
              ref="addItem"
            ></add-products>

            <!--begin::Button-->

            <div
              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"
              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="permissionChecker('export')"
            >
              <button
                @click="$refs.exportSidebar.$data.exportSidebar = true"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-export-variant</v-icon>
                </span>
                Export
              </button>
            </div>

            <!--end::Button-->

            <div
              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"
              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="filters.length > 0"
            >
              <button
                @click="$refs.filterSidebar.$data.filterSidebar = true"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-filter</v-icon>
                </span>
                Filter
              </button>
            </div>
          </div>
        </div>
        <!-- Export Sidebar start -->
        <ExportSidebar
          ref="exportSidebar"
          :exportHeaders="exportHeaders"
          :downloadItem="downloadItem"
          :submitFilterValues="submitFilterValues"
          :resetFilterValues="resetFilterValues"
          :filters="filters"
          :setTableFiltersValues="setTableFiltersValues"
        />
        <!--        end::Export Sidebar-->

        <!-- Filter Sidebar start -->
        <FilterSidebar
          ref="filterSidebar"
          :submitFilterValues="submitFilterValues"
          :resetFilterValues="resetFilterValues"
          :filters="filters"
          :setTableFiltersValues="setTableFiltersValues"
        />
        <!--end::Filter Sidebar-->

        <!-- filter container end -->
      </template>
      <template
        v-slot:header.data-table-select="{ props: { value }, on: { input } }"
      >
        <div
          class="form-check form-check-sm form-check-custom form-check-solid mr-5 min-w-20px min-h-20px"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="allSelected"
            @click="selectAll"
          />
        </div>
      </template>

      <template v-slot:item.data-table-select="{ item }">
        <div
          class="form-check form-check-sm form-check-custom form-check-solid mr-5 min-w-20px min-h-20px"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="selected"
            @click="selectOne"
            :value="item"
          />
        </div>
      </template>
      <!-- top end -->
      <!-- column start -->
      <template #item.id="{ item, header, value }">
        <span :class="header.itemClass">
          {{ value }}
        </span>
      </template>
      <template #item.store_group="{ item, header, value }">
        <store-item :header="header" :store="value"></store-item>
      </template>

      <template #item.photo="{ item, header, value }">
        <ShowUrlImage :url="value"></ShowUrlImage>
      </template>
      <template #item.category="{ item, header, value }">
        <show-simple-content
          :itemForAction="value.title"
          :itemClass="header.itemClass"
          :item="item"
        ></show-simple-content>
      </template>
      <template #item.brand="{ item, header, value }">
        <show-simple-content
          :itemForAction="value.title"
          :itemClass="header.itemClass"
          :item="item"
        ></show-simple-content>
      </template>
      <template #item.name="{ item, header, value }">
        <show-simple-content
          :itemForAction="value"
          :itemClass="header.itemClass"
          :item="item"
        ></show-simple-content>
      </template>
      <template #item.description="{ item, header, value }">
        <ShowCustomContent
          :itemForAction="value"
          :item="item"
          :header="header"
        ></ShowCustomContent>
      </template>
      <template #item.home_page_label="{ item, header, value }">
        <StatusColumn
          class="d-flex justify-center align-content-start w-70px"
          :value="value"
        ></StatusColumn>
      </template>
      <template #item.created_at="{ item, header, value }">
        <div :class="header.itemClass">
          {{ new Date(value * 1000).toLocaleDateString() }}
        </div>
      </template>
      <template #item.updated_at="{ item, header, value }">
        <div :class="header.itemClass">
          {{ new Date(value * 1000).toLocaleDateString() }}
        </div>
      </template>
      <template #item.action="{ item, header, value }">
        <DataTableActionSelector
          :item="item"
          :header="header"
          :value="value"
          :actions="actions"
          :handle_function_call="handle_function_call"
        ></DataTableActionSelector>
        <show-sku
          :product_id="item.id"
          :loader="pageLoad"
          :ref="`showSkuModal_${item.id}`"
        ></show-sku>
        <add-sku
          :itemForAction="item"
          :loader="pageLoad"
          :refresher="updateTableContent"
          :brands="brands"
          :parameters="parameters"
          :stores="stores"
          :ref="`addModal_${item.id}`"
        ></add-sku>
        <edit-product
          :stores="stores"
          :brands="brands"
          :parameters="parameters"
          :itemForAction="item"
          :refresher="updateTableContent"
          :loader="pageLoad"
          :ref="`editModal_${item.id}`"
        ></edit-product>
      </template>
      <!-- column end -->
    </v-data-table>
    <Pagination
      v-if="items.length"
      :setitemPerPage="setitemPerPage"
      :getitemPerPage="getitemPerPage"
      :getpageNumber="getpageNumber"
      :setpageNumber="setpageNumber"
      :totalItems="totalItems"
      :pageCount="pageCount"
      :updateTableContent="updateTableContent"
    ></Pagination>
  </div>
</template>

<script>
import {
  UPDATE_TABLE_STRUCTURE,
  UPDATE_TABLE_DATA,
  SET_TABLE_SORTBY,
  UPDATE_CREATE_DATA,
  SET_TABLE_SORTORDER,
  SET_TABLE_FILTER,
  SET_TABLE_PERPAGE,
  SET_TABLE_PAGE,
  EXPORT_TABLE_DATA,
} from "@/core/services/store/products.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

import StoreItem from "@/own/components/datatable/StoreItem.vue";
import ShowUrlImage from "@/own/components/datatable/ShowUrlImage.vue";
import ShowSimpleContent from "@/own/components/datatable/ShowSimpleContent.vue";
import ShowCustomContent from "@/own/components/datatable/ShowCustomContent.vue";
import AddProducts from "@/own/components/stores/products/AddProducts.vue";
import ShowSku from "@/own/components/stores/products/skus/ShowSku.vue";
import AddSku from "@/own/components/stores/products/AddSku.vue";
import EditProduct from "@/own/components/stores/products/EditProduct.vue";
import Pagination from "@/own/components/pagination/Pagination.vue";
import FilterSidebar from "@/own/components/sidebars/FilterSidebar.vue";
import ExportSidebar from "@/own/components/sidebars/ExportSidebar.vue";
import Swal from "sweetalert2";
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import ApiService from "@/core/services/api.service";
import DataTableActionSelector from "@/own/components/DataTableActionSelector.vue";
import StatusColumn from "@/own/components/datatable/StatusColumn";

export default {
  name: "DataTable",
  components: {
    DatatableDetail,
    Pagination,
    StoreItem,
    ShowCustomContent,
    ShowSimpleContent,
    AddProducts,
    ShowUrlImage,
    EditProduct,
    AddSku,
    ShowSku,
    FilterSidebar,
    ExportSidebar,
    DataTableActionSelector,
    StatusColumn,
  },
  data: () => ({
    toolBarVisionState: false,
    selected: [],
    offset: true,

    allSelected: false,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {}).then(() => {});
    this.$store.dispatch(UPDATE_CREATE_DATA, {}).then(() => {});
    this.$store.dispatch(UPDATE_TABLE_DATA, {}).then(() => {});
  },
  beforeCreate() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
  computed: {
    isToolbarVisiable: function () {
      return this.$vuetify.breakpoint.smAndUp ? true : this.toolBarVisionState;
    },
    actions: function () {
      return [
        {
          title: "Show Sku",
          method: "showSku",
          isVisible: true,
        },
        {
          title: "Add Sku",
          method: "addItem",
          isVisible: this.permissionChecker("create"),
        },
        {
          title: "Edit",
          method: "editItem",
          isVisible: this.permissionChecker("update"),
        },
        {
          title: "Remove",
          method: "removeItem",
          isVisible: this.permissionChecker("destroy"),
        },
      ];
    },
    //pagination
    getitemPerPage: function () {
      return this.$store.getters.getPRODUCTSTableState.per_page;
    },
    getpageNumber: function () {
      return this.$store.getters.getPRODUCTSTableState.page;
    },
    totalItems: function () {
      return this.$store.getters.getPRODUCTSTableData.total;
    },
    pageCount: function () {
      return this.$store.getters.getPRODUCTSTableData.last_page;
    },
    //filters
    filters: function () {
      return this.$store.getters.getPRODUCTSTableFilters;
    },
    itemPerPage: function () {
      return this.$store.getters.getPRODUCTSTableState.per_page;
    },
    orderBy: {
      get: function () {
        return this.$store.getters.getAPPSTableState.sortBy;
      },
      set: function (newValue) {
        if (newValue) {
          this.$store.commit(SET_TABLE_SORTBY, newValue);
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getAPPSTableState
          );
        } else {
          this.$store.commit(SET_TABLE_SORTBY, newValue);
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getAPPSTableState
          );
        }
      },
    },
    sortOrder: {
      get: function () {
        let sortOrder = true;
        if (this.$store.getters.getAPPSTableState.sortOrder === "asc") {
          sortOrder = false;
        }
        return sortOrder;
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.commit(SET_TABLE_SORTORDER, "desc");
        } else {
          this.$store.commit(SET_TABLE_SORTORDER, "asc");
        }
        this.$store.dispatch(
          UPDATE_TABLE_DATA,
          this.$store.getters.getAPPSTableState
        );
      },
    },

    headers: function () {
      let headers = false;
      if (this.$vuetify.breakpoint.smAndDown) {
        if (this.$store.getters.getPRODUCTSTableHeaders) {
          headers = this.$store.getters.getPRODUCTSTableHeaders.filter(
            (col) => col.visible === true && col.mobile_visible === true
          );
        } else {
          this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {});
          headers = this.$store.getters.getPRODUCTSTableHeaders.filter(
            (col) => col.visible === true && col.mobile_visible === true
          );
        }
      } else {
        if (this.$store.getters.getPRODUCTSTableHeaders) {
          headers = this.$store.getters.getPRODUCTSTableHeaders.filter(
            (col) => col.visible === true
          );
        } else {
          this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {});
          headers = this.$store.getters.getPRODUCTSTableHeaders.filter(
            (col) => col.visible === true
          );
        }
      }
      headers.forEach((header) => {
        header.class =
          "text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        header.itemClass = "second-text";
        header.width = undefined;
        if (header.value === "action") {
          header.class =
            "pr-10 text-end text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        }
      });
      return headers;
    },
    exportHeaders: function () {
      try {
        return this.$store.getters.getPRODUCTSTablePermissions.filter(
          (col) => col.name === "export"
        )[0].columns;
      } catch (error) {
        return null;
      }
    },
    items: function () {
      if (this.$store.getters.getPRODUCTSTableData) {
        return this.$store.getters.getPRODUCTSTableData.data;
      }
      return undefined;
    },
    table_permissions: function () {
      if (this.$store.getters.getPRODUCTSTablePermissions) {
        return this.$store.getters.getPRODUCTSTablePermissions.map(function (
          perm
        ) {
          return perm.name;
        });
      } else {
        return false;
      }
    },
    table_properties: function () {
      return this.$store.getters.getPRODUCTSTableProperties;
    },
    brands: function () {
      if (this.$store.getters.getPRODUCTSBrandsData) {
        return this.$store.getters.getPRODUCTSBrandsData;
      }
      return undefined;
    },
    stores: function () {
      if (this.$store.getters.getPRODUCTSStoresData) {
        return this.$store.getters.getPRODUCTSStoresData;
      }
      return undefined;
    },
    parameters: function () {
      if (this.$store.getters.getPRODUCTSParametersData) {
        return this.$store.getters.getPRODUCTSParametersData;
      }
      return undefined;
    },
  },
  methods: {
    deleteAllItems() {
      this.selected.splice(0, this.selected.length);
      this.allSelected = false;
    },
    selectOne(event) {
      this.allSelected && this.deleteItem(event.target.value);

      this.allSelected = false;
    },
    selectAll(event) {
      this.deleteAllItems();
      if (event.target.checked) {
        this.items.forEach((item) => {
          this.selected.push(item);
        });
      }
    },
    // pagination
    setitemPerPage(val) {
      this.$store.commit(SET_TABLE_PERPAGE, val);
      this.$store.commit(SET_TABLE_PAGE, 1);
      this.deleteAllItems();
    },
    setpageNumber(val) {
      this.$store.commit(SET_TABLE_PAGE, val);
      this.deleteAllItems();
    },
    // pagination end
    // filters
    setTableFiltersValues(val) {
      this.$store.commit(SET_TABLE_FILTER, val);
    },
    submitFilterValues() {
      this.$store.commit(SET_PAGE_LOADING, true);
      let state = { ...this.$store.getters.getPRODUCTSTableState };
      state.page = 1;
      this.$store
        .dispatch(UPDATE_TABLE_DATA, state)
        .then(() => {
          this.$store.commit(SET_TABLE_PAGE, 1);
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch((res) => {
          this.$store.commit(SET_PAGE_LOADING, false);
          Swal.fire({
            title: "",
            text: `${res}`,
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    resetFilterValues() {
      this.$store.commit(SET_PAGE_LOADING, true);
      this.$store.commit(SET_TABLE_FILTER, []);
      this.$store
        .dispatch(UPDATE_TABLE_DATA, this.$store.getters.getPRODUCTSTableState)
        .then(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    // filters end
    permissionChecker(permType) {
      return !!this.table_permissions.includes(permType);
    },
    handle_function_call(function_name, prop) {
      // console.log(function_name, prop);
      this[function_name](prop);
    },
    editItem(item) {
      this.$refs[`editModal_${item.id}`].toggleModal();
    },
    showSku(item) {
      this.$refs[`showSkuModal_${item.id}`].toggleModal();
    },
    addItem(item) {
      this.$refs[`addModal_${item.id}`].toggleModal();
    },
    showHeader(item) {
      this.$refs[`headerModal_${item.id}`].toggleModal();
    },
    showBody(item) {
      this.$refs[`bodyModal_${item.id}`].toggleModal();
    },
    removeItem(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.pageLoad(true);
          const data = {
            id: item.id,
          };
          ApiService.post("/stores/portal/products/destroy", data)
            .then(() => {
              Swal.fire("Deleted!", "The product has been deleted.", "success");
              this.updateTableContent();
            })
            .catch(() => {
              this.pageLoad(false);
            });
        }
      });
    },
    pageLoad(state) {
      this.$store.commit(SET_PAGE_LOADING, state);
    },
    async updateTableContent() {
      this.pageLoad(true);
      await this.$store
        .dispatch(UPDATE_TABLE_DATA, this.$store.getters.getPRODUCTSTableState)
        .then(() => {});
      this.$forceUpdate();
      this.pageLoad(false);
    },
    showAddItemModal() {
      this.$refs.addItem.toggleModal();
    },
    // showAddParameterModal() {
    //   this.$refs.addParameter.toggleModal();
    // },
    //---------------------export-------------------------
    downloadItem(columns) {
      this.$store.commit(SET_PAGE_LOADING, true);
      this.export_modal = false;
      this.$store
        .dispatch(EXPORT_TABLE_DATA, {
          columns: columns,
          filters: this.$store.getters.getPRODUCTSTableState.filters,
        })
        .then(() => {
          const link = document.createElement("a");
          link.href = this.$store.getters.getPRODUCTSExportUrl;
          link.download = "ProblemWithExport.csv";
          link.click();
          setTimeout(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          }, 1500);
          this.$refs.exportSidebar.$refs.export.toggleModal();
        });
    },
  },
};
</script>
